export default __webpack_public_path__ + "static/media/pick-logo.d9a4144a.png";